const BookRibbon = props => (
  <div className="bookRibbonWrapper">
    <span className="bookRibbon">{ props.children }</span>
  </div>
)

export default BookRibbon
